module.exports = __webpack_public_path__ + "img/iata1.4828c82e.png";